import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import light from '../../../assets/style/themes/dark';
import { Logo, Version, Button, Loading } from '../../../components';
import { updatePassword, tokenValidation } from '../../../stores/actions/recoverPassword';
import * as Ui from '../styles';
import version from '../../../version.json';
import PasswordFormCard from './CardContent/passwordFormCard';
import PasswordUpdatedCard from './CardContent/passwordUpdatedCard';
import InvalidToken from './CardContent/invalidToken';

// Mensagens de erro
const errTokenExpired = 'Não existe usuário com o e-mail cadastrado';
const errFailOnRequest = 'Houve uma falha na requisição ou no servidor';
const internalServerError = 'Erro interno do servidor';

function RecoverPasswordConfirm({ running, dispatch, passwordUpdated, location, error, isTokenValid, emailSent }) {
  const theme = light;
  const token = new URLSearchParams(location.search).get('token');
  const [showContent, setShowContent] = useState(false);
  /*
  função que chama o action para atualização de senha
    @params(password) nova senha
  */
  function handleSubmit(password) {
    updatePassword(token, password, dispatch);
  }

  // error effect
  useEffect(() => {
    if (error) {
      const errResp = error.response;
      if (errResp.status === 400) {
        toast.error(errTokenExpired);
      } else if (errResp.status > 500) {
        toast.error(errFailOnRequest);
      } else if (errResp.data.errors) {
        const serverErrorsMessage = errResp.data.errors.reduce((accumulator, currentValue) => `${accumulator}<br/>${currentValue.toString()}`);
        toast.error(serverErrorsMessage);
      } else if (errResp.status === 500) {
        toast.error(internalServerError);
      } else {
        toast.error(errResp.data);
      }
    }
  }, [error]);

  useEffect(() => {
    tokenValidation(token, dispatch);
    setShowContent(true);
  }, []);

  /*
    Renderiza o conteúdo de acordo com o estado do passwordUpdated caso o password tenha sido atualizado
    retorna o componente de sucesso
  */
  function renderContent() {
    if (showContent) {
      if (!isTokenValid && !running) {
        return <InvalidToken />;
      }
      if (passwordUpdated && !running) {
        return <PasswordUpdatedCard running={emailSent} handleSubmit={handleSubmit} />;
      }
      if (!running) {
        return <PasswordFormCard running={emailSent} handleSubmit={handleSubmit} />;
      }
    }
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <Ui.PageWrapper>
        <Ui.Header>
          <Logo />
          <Version value={version.value} />
        </Ui.Header>
        {renderContent()}
        <Ui.Footer>
          <div className="copyright">
            <span>&copy; 2020 Analyze</span>
          </div>
        </Ui.Footer>
      </Ui.PageWrapper>
    </ThemeProvider>
  );
}
const mapStateToProps = (state) => {
  const recoverPasswordState = state.recoverPassword;

  return {
    passwordUpdated: recoverPasswordState.passwordUpdated,
    running: recoverPasswordState.running,
    emailSent: recoverPasswordState.emailSent,
    error: recoverPasswordState.error,
    isTokenValid: recoverPasswordState.isTokenValid,
  };
};
export default connect(mapStateToProps)(RecoverPasswordConfirm);
